import { createReducer, on } from '@ngrx/store';
import * as RewardLogsActions from './reward-logs.actions';
import { initialRewardLogsState } from './reward-logs.state';

export const rewardLogsReducer = createReducer(
  initialRewardLogsState,

  on(RewardLogsActions.loadRewardLogs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardLogsActions.loadRewardLogsSuccess, (state, { rewardLogs, pagination }) => ({
    ...state,
    rewardLogs,
    loading: false,
    error: null,
    pagination,
  })),

  on(RewardLogsActions.loadRewardLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(RewardLogsActions.createRewardLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardLogsActions.createRewardLogSuccess, (state, { rewardLog }) => ({
    ...state,
    rewardLogs: [ rewardLog, ...state.rewardLogs ],
    loading: false,
    error: null,
  })),

  on(RewardLogsActions.createRewardLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(RewardLogsActions.deleteRewardLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardLogsActions.deleteRewardLogSuccess, (state, { id }) => ({
    ...state,
    rewardLogs: state.rewardLogs.filter(rl => rl.id !== id),
    loading: false,
    error: null,
  })),

  on(RewardLogsActions.deleteRewardLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

